//
// math-clamp.js - clamp a number to a range
//

export default function math_clamp(n, range) {
  range = range.sort();
  return Math.min(Math.max(n, range[0]), range[1]);
}
